module.exports = __webpack_public_path__ + "img/fabulous3.d488c5d4.svg";